module.exports = __webpack_public_path__ + "img/esmeralda-pool.68338f2a.jpg";